module.exports = __webpack_public_path__ + "be0235ba474237de4eaf703e7451d6ee.pdf";